module.exports = __webpack_public_path__ + "static/media/shipping.7d0605e6.avif";